import React, {Suspense, useCallback, useEffect, useRef, useState} from 'react';
import "../Css/MenuPage.scss";
import leaf from "../Backgrounds/topContainer.svg"
import logo from "../Backgrounds/logo.png"
import {NumericFormat} from "react-number-format";
import Scrollbars from "react-custom-scrollbars-2";
import useWindowDimensions from "../Wedgits/useWindowDimensions";
import toast from "react-hot-toast";
import axios from "axios";
import PreviewPage from "./PreviewPage";
import MenuContent from "./MenuContent";
import AboutUs from "./AboutUs";
import ComplexInfo from "./ComplexInfo";
import {Link, Navigate, Route, Routes, useNavigate} from "react-router-dom";
import LoadingSpinner from "../Wedgits/LoadingSpinner";

function Container(props) {


    // axios.defaults.baseURL = 'http://192.168.2.12:1234';
    axios.defaults.baseURL = "https://api.mealland.ir";
    axios.defaults.url = "1719730216e09a1ff1";

    const navigate = useNavigate();

    const {height, width} = useWindowDimensions();

    const [isFetchOver, setIsFetchOver] = useState(false);
    const [isPreviewIsOver, setIsPreviewIsOver] = useState(false);

    const [selectedPageTitle, setSelectedPageTitle] = useState("AboutUs");

    useEffect(() => {

        setTimeout(() => {
            setIsPreviewIsOver(true);
        }, 2000);
    }, []);

    const MenuPage = React.lazy(() => import('./MenuContent'));
    const AboutUs = React.lazy(() => import('./AboutUs'));
    const ComplexInfo = React.lazy(() => import('./ComplexInfo'));

    return (
        <div className="menuContainer">
            <PreviewPage isPreviewIsOver={isPreviewIsOver && isFetchOver}/>
            <div className="backgroundContainer"></div>

            <div className="topContent">
                <div className="leafLeft">
                    <img src={leaf} alt="leafDesign"/>
                </div>
                <Link to={"/info"}>
                    <p className={`${window.location.pathname == "/info" ? "active" : ""}`} onClick={() => {
                        setSelectedPageTitle("ComplexInfo");
                    }}>تماس با ما </p>
                    <div className={`IcoContainer ${window.location.pathname == "/info" ? "active" : ""}`}
                         onClick={() => {
                         }}>
                        <svg width="200" height="200" viewBox="0 0 200 200" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M154.542 0C129.677 0 109.567 18.866 109.567 42.1923C109.567 73.8364 154.542 120.549 154.542 120.549C154.542 120.549 199.517 73.8364 199.517 42.1923C199.517 18.866 179.407 0 154.542 0ZM122.416 42.1917C122.416 25.5559 136.808 12.0544 154.541 12.0544C172.275 12.0544 186.667 25.5559 186.667 42.1917C186.667 59.5508 168.162 85.5292 154.541 101.743C141.177 85.6497 122.416 59.37 122.416 42.1917ZM137.681 46.5109C137.681 37.4448 145.16 30.0952 154.386 30.0952C160.354 30.0952 165.869 33.224 168.853 38.303C171.837 43.3821 171.837 49.6397 168.853 54.7187C165.869 59.7977 160.354 62.9265 154.386 62.9265C145.16 62.9265 137.681 55.577 137.681 46.5109Z"
                                  fill="white"/>
                            <path className="fill" fill-rule="evenodd" clip-rule="evenodd"
                                  d="M0 70C0 31.3 33.3645 0 74.6171 0C115.87 0 149.234 31.3 149.234 70C149.234 122.5 74.6171 200 74.6171 200C74.6171 200 0 122.5 0 70ZM46.6417 77.1649C46.6417 62.1235 59.0501 49.9301 74.3566 49.9301C84.2582 49.9301 93.4077 55.121 98.3585 63.5475C103.309 71.9739 103.309 82.3558 98.3585 90.7822C93.4077 99.2087 84.2582 104.4 74.3566 104.4C59.0501 104.4 46.6417 92.2062 46.6417 77.1649Z"
                                  fill="white"/>
                        </svg>
                    </div>
                </Link>

                <Link to={"/menu"}>
                    <p className={`${window.location.pathname == "/menu" ? "active" : ""}`} onClick={() => {
                    }}>منو</p>
                    <div className={`IcoContainer ${window.location.pathname == "/menu" ? "active" : ""}`}
                         onClick={() => {
                         }}>
                        <svg width="200" height="200" viewBox="0 0 200 200" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path className="fill"
                                  d="M56.0642 112.429L85.6653 81.2561L12.2379 4.03925C-4.0793 21.223 -4.0793 49.0916 12.2379 66.3855L56.0642 112.429Z"
                                  fill="white"/>
                            <path className="fill"
                                  d="M126.981 92.4912C142.985 100.312 165.473 94.8044 182.104 77.2902C202.082 56.2511 205.952 26.0693 190.576 9.87689C175.305 -6.20536 146.646 -2.23988 126.563 18.7992C109.932 36.3135 104.702 59.9963 112.128 76.8496L10.0413 184.358L24.7895 199.89L96.8571 124.215L168.82 200L183.568 184.469L111.605 108.684L126.981 92.4912Z"
                                  fill="white"/>
                        </svg>
                    </div>
                </Link>

                <Link to={"/"}>
                    <p className={`${window.location.pathname == "/" ? "active" : ""}`} onClick={() => {
                    }}>صفحه نخست</p>
                    <div className={`IcoContainer ${window.location.pathname == "/" ? "active" : ""}`} onClick={() => {
                    }}>
                        <svg width="190" height="200" viewBox="0 0 190 200" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path className="fill"
                                  d="M79.4118 0C101.495 0 119.412 17.8981 119.412 39.9568C119.412 62.0155 101.495 79.9136 79.4118 79.9136C57.3289 79.9136 39.4112 62.0155 39.4112 39.9568C39.4112 17.8981 57.3093 0 79.4118 0ZM79.4118 200C35.5604 200 0 197.429 0 160.593C0 123.756 35.5604 93.9064 79.4118 93.9064C123.263 93.9064 158.824 123.756 158.824 160.593C158.824 197.429 123.263 200 79.4118 200Z"
                                  fill="white"/>
                            <path
                                d="M122.192 9.46594C140.809 9.46594 155.892 24.0499 155.892 41.9966C155.892 59.9432 140.809 74.5272 122.192 74.5272C103.576 74.5272 88.4929 59.9432 88.4929 41.9966C88.4929 24.0498 103.559 9.46594 122.192 9.46594ZM122.192 173.422C103.502 173.422 86.6571 172.889 74.4857 168.593C68.4095 166.448 63.5261 163.374 60.1598 158.984C56.7962 154.598 54.9204 148.863 54.9204 141.344C54.9204 111.284 84.9679 86.8006 122.192 86.8006C159.417 86.8006 189.465 111.284 189.465 141.344C189.465 148.863 187.589 154.598 184.225 158.984C180.859 163.374 175.975 166.448 169.899 168.593C157.728 172.889 140.882 173.422 122.192 173.422Z"
                                stroke="white" stroke-width="0.75"/>
                        </svg>
                    </div>
                </Link>

                <div className="leafRight">
                    <img src={leaf} alt="leafDesign"/>
                </div>

                <div className="logoContainer">
                    <Link to={"/"}>
                        <img src={logo} alt={"فردیس"}/>
                    </Link>
                </div>
            </div>

            {/*{*/}
            {/*    selectedPageTitle == "MenuContent" ?*/}
            {/*        <MenuContent onSetIsFetchOver={setIsFetchOver}/>*/}
            {/*        : selectedPageTitle == "AboutUs" ?*/}
            {/*            <AboutUs/>*/}
            {/*            : selectedPageTitle == "ComplexInfo" &&*/}
            {/*            <ComplexInfo/>*/}
            {/*}*/}

            <Routes>
                <Route
                    element={
                        <Suspense fallback={<LoadingSpinner/>}>
                            <AboutUs onSetIsFetchOver={setIsFetchOver}/>
                        </Suspense>
                    }
                    exact
                    path="/"
                />
                <Route
                    element={
                        <Suspense fallback={<LoadingSpinner/>}>
                            <ComplexInfo onSetIsFetchOver={setIsFetchOver}/>
                        </Suspense>
                    }
                    exact
                    path="/info"
                />
                <Route
                    element={
                        <Suspense fallback={<LoadingSpinner/>}>
                            <MenuPage onSetIsFetchOver={setIsFetchOver}/>
                        </Suspense>
                    }
                    exact
                    path="/menu"
                />
                <Route path="*" element={<Navigate to="/" replace/>}/>
            </Routes>

            {/*<div className="bottomNav">*/}
            {/*    <button className="menuBtn">*/}
            {/*        منو*/}
            {/*    </button>*/}
            {/*    <button className="evaluationBtn">*/}
            {/*        نظرسنجی*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
}

export default Container;
